export default [
  {
    path: '/dashboard',
    component: () => import('@/views/dashboard/dashboard.vue')
  },
];
